import React from 'react';

import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from '../tabs.component.module.styl';

import type {ReactNode} from 'react';


const classes = hashedClasses(styles);

interface TabBadgeProps {
    children: ReactNode,
}

export const TabBadge = ({children}: TabBadgeProps) => {
    return <div className={classes.tabs__badge}>{children}</div>;
};

TabBadge.displayName = 'TabBadge';
